import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { GlobalInfo } from "../../Contexts/GlobalContext";
import Logo from '../../Assets/images/logo.png';
import { DonorService } from "../../Services/Donor.Service";
import Toaster from "../../Components/Toaster";
import Loader from "../../Components/Loader";
import { getErrorMessagesList } from "../../Utils/Common";

const PaymentConfirm = () => {
    const { token } = useParams();
    const [amount, setAmount] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState([]);
    const { appUserIsLogin,  setIsLoggedIn} = useContext(GlobalInfo);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const navigate = useNavigate();
    useEffect(() => {
        const verifyToken = async () => {
            try {
                const res = await DonorService.verifyPaymentMethodToken({
                    payment_token: token
                });

                // If API returns status true ie token is not used ie is valid
                if (!res.status) {
                    navigate('/login');
                    setShowToast(true);
                    if(appUserIsLogin){
                        setIsLoggedIn(true);
                    }
                    setToastMessage("Payment verification token got expired");
                    setToastVariant("error");
                }
            } catch (e) {
                // API error also means invalid/expired token
                navigate('/login');
            }
        };

        verifyToken();

        // user should not be logged in on this screen
        if (setIsLoggedIn) {
            setIsLoggedIn(false);
        }
    }, [token, setIsLoggedIn]);

    
   const handleVerify = async () => {
    setMessage([]);

    if (error) return;

    if (!amount) {
        setError("Please Enter Payment Received Amount.");
        return;
    }

    setError("");
    setLoading(true);

    try {
        const result = await DonorService.confirmDonorPayment(token, amount);
        if(result.status){
            setShowToast(true);
            setToastMessage(result.message);
            setToastVariant("success");
            // setMessage(getErrorMessagesList(result));
        }
        else{
            setMessage(getErrorMessagesList(result));
        }
            
    } catch (err) {
        setMessage(getErrorMessagesList(err));
    }

    setLoading(false);
};



    return (
        <div className="payment-center-wrapper">
            <div className="payment-confirm-container">
                <div className="payment-box">
                <div className="el-login-logo text-center mb-3">
                    <img src={Logo} className="img-fluid logindonar-x-logo" alt="donor x" />
                </div>
                <h4 className="text-center mb-3">Verify Your Payment Method</h4>

                <p className="mt-2">
                    You're almost there! To finish setting up your preferred payment method, check your [PayPal/Venmo] account for a tiny deposit from us — we’re talking as little as $0.01 tiny. Enter that exact amount below to confirm it’s really you. Don’t see anything yet? No worries — it can take up to 12 hours to show up.
                </p>

                <input
                    type="text"
                    className="form-control mt-3"
                    placeholder="Received Amount"
                    value={amount}
                    onChange={(e) => {
                        let value = e.target.value.trim();

                        // Block only dot
                        if (value === ".") {
                            setError("Please Enter Valid Payment Received Amount.");
                            return;
                        }

                        // Block value starting with dot (.1)
                        if (value.startsWith(".")) {
                            setError("Please Enter Valid Payment Received Amount.");
                            return;
                        }

                        // Allow only digits + one decimal
                        if (!/^\d*\.?\d*$/.test(value)) return;

                        // Block ending with dot (1.)
                        if (value.endsWith(".")) {
                            setError("Please Enter Valid Payment Received Amount.");
                            setAmount(value);
                            return;
                        }

                        //  NEW RULE: Total characters INCLUDING dot must be ≤ 4
                        if (value.length > 4) {
                            setError("Please enter not more than 4 characters.");
                            return;
                        }

                        // Clear error + update value
                        setError("");
                        setAmount(value);
                    }}
                />



                {error && <p className="text-danger">{error}</p>}

                <button className="el-main-button mt-3 m-auto" onClick={handleVerify} disabled={loading}>
                <span> {loading ? "Verifying..." : "Verify"}</span>
                </button>

                {message.length > 0 && (
                    <div className="mt-3 text-danger">
                        {message.map((m, i) => (
                            <div key={i}>{m}</div>
                        ))}
                    </div>
                )}

                </div>
            </div>
            <Loader loading={loading} /> 

            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
    );
};

export default PaymentConfirm;
